module.exports = __webpack_public_path__ + "img/social-vk.4442a99c.svg";